import Alert, { AlertProps } from "@mui/material/Alert";

const DXAlert = (props: AlertProps) => {
  return <Alert sx={{ fontWeight: 600 }} {...props}></Alert>;
};

export default DXAlert;
